import { Skeleton } from '@mui/material';
import React from 'react';

const SkeletonLayout = ({ extended = false }: { extended?: boolean }) => {
    return (
        <>
            <Skeleton variant='text' width={250} />
            <Skeleton variant='rounded' width={100} height={50} />
            {extended && <Skeleton variant='text' width={125} sx={{ mt: 1 }} />}
        </>
    );
};

export default SkeletonLayout;
